import React, { useState } from 'react'
import AffiliationSetup from './AffiliationSetup'
import qc from 'keys/queryClient'
import { getAffiliationsFetch } from 'store/middlewares/affiliation.crud'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { alerts } from 'keys'

// דשבורד עבור יצירה של  תהליך רישום בית ספר
const AffiliationSetupPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [affiliation, setAffiliation] = useState(null)

    const affiliations = useQuery({
        queryKey: [qc.affiliations],
        queryFn: async () => {
            const { data } = await getAffiliationsFetch()
            if (data.length == 1) {
                setAffiliation(data[0])
            }
            else {
                navigate(app.affiliations)
            }
            return data
        }
    })

    const handleAlert = (val) => {
        dispatch(actions.setAlerts({ key: alerts.schoolSetup, value: { open: val, props: null } }))
    }

    const commonState = {
        // affiliations,
        handleAlert,
        affiliation, setAffiliation
    }

    return (
        <AffiliationSetupContext.Provider value={commonState}>
            <AffiliationSetup />
        </AffiliationSetupContext.Provider>
    )
}

export const AffiliationSetupContext = React.createContext()
export default AffiliationSetupPage